module.exports = __webpack_public_path__ + "static/media/wheel-spin.9c2ddc28.svg";